import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Log, LogsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class LogsDataService {

  private uri: string = `${environment.apiUrl}logs`;
  private cacheKey: string = 'logs.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getLog(id: number): Observable<Log|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getLogs(parameters: {[param: string]: string | string[]}): Observable<LogsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addLog(data: Log): Observable<Log|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addLogs(data: Log[]): Observable<Log[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateLog(data: Log): Observable<Log|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateLogs(data: Log[]): Observable<Log[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchLog(data: Log): Observable<Log|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchLogs(data: Log[]): Observable<Log[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteLog(data: Log): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteLogs(data: Log[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((log) => {
      ids.push(log.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
